import { AccountLevelEnum } from '@app/app.enum';
import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';
import * as queryString from 'query-string';

@Injectable()
export class AdminAccountService {
	private baseUrl = environment.apiGateway.apiUrl;
	private adminApiUrl = '';

	constructor() {
		this.adminApiUrl = this.baseUrl + 'AdminAccount/';
	}

	/**
	 * Get all account  as child for admin
	 * @param selectedPartnerFilterValues
	 * @param selectedStatusFilterValues
	 * @param customerVisibleAccountNumber
	 * @param cancelToken
	 */
	public async getAllAccountForAdmin(
		selectedStatusFilterValues: string[],
		selectedSubscriptionFilterValues: string[],
		customerSearch: string,
		partnerSearch: string,
		level: AccountLevelEnum,
		cancelToken?: CancelToken
	): Promise<models.IChildAccountResponseVM[]> {
		const url = this.adminApiUrl + 'Accounts';
		const res = await axios.get<models.IChildAccountResponseVM[]>(url, {
			cancelToken,
			params: {
				accountStatus: selectedStatusFilterValues,
				customerSearch,
				partnerSearch,
				subscriptions: selectedSubscriptionFilterValues,
				accountLevel: level,
			},
			paramsSerializer: (params) => queryString.stringify(params),
		});
		return res.data;
	}

	/**
	 * Get account by accountId for admin
	 * @param accountId
	 * @param cancelToken
	 */
	public async getAccountByAccountId(
		accountId: string,
		cancelToken?: CancelToken
	): Promise<models.ICustomerAccountDetails> {
		const url = this.adminApiUrl + accountId;
		const res = await axios.get<models.ICustomerAccountDetails>(url, {
			cancelToken,
		});
		return res.data;
	}

	/**
	 * Adjust Balance for admin
	 * @param data
	 * @param cancelToken
	 */
	public async AdjustBalance(data: models.IAdjustBalanceRequest, cancelToken?: CancelToken): Promise<models.IAccount> {
		const url = this.adminApiUrl + 'AdjustBalance';
		const res = await axios.put<models.IAccount>(url, data, {
			cancelToken,
		});
		return res.data;
	}

	/**
	 * Get static data for subscription plan
	 * @param cancelToken
	 */
	public async GetSubscriptionPlanStaticData(cancelToken?: CancelToken): Promise<models.ISubscriptionPlan[]> {
		const url = this.adminApiUrl + 'Product';
		const res = await axios.get<models.ISubscriptionPlan[]>(url, {
			cancelToken,
		});
		return res.data;
	}

	/**
	 * Update subscription plan
	 * @param data
	 * @param cancelToken
	 */
	public async UpdateSubscriptionPlan(
		data: models.ISubscriptionPlanUpdate,
		cancelToken?: CancelToken
	): Promise<models.IAccount> {
		const url = this.adminApiUrl + 'Product';
		const res = await axios.put<models.IAccount>(url, data, {
			cancelToken,
		});
		return res.data;
	}

	/**
	 * Update USPS Tier Config For Admin
	 * @param data
	 * @param cancelToken
	 */
	public async updateUSPSTierForAccount(data: any, cancelToken?: CancelToken): Promise<any> {
		const url = this.adminApiUrl + 'USPSTier';
		const res = await axios.put<any>(url, data, {
			cancelToken,
		});
		return res.data;
	}

	public async getAllUsersByAccountIdForAdmin(accountId: string, cancelToken?: CancelToken): Promise<any> {
		const url = this.adminApiUrl + `${accountId}/Users`;
		const res = await axios.get<any>(url, {
			cancelToken,
		});

		return res.data;
	}

	public async getDisabledCarrierServices(
		accountId: string,
		cancelToken?: CancelToken
	): Promise<models.IAccountDisableService[]> {
		const url = this.adminApiUrl + 'Service';
		const res = await axios.get<models.IAccountDisableService[]>(url, {
			params: {
				accountId,
			},
			cancelToken,
		});
		return res.data;
	}

	public async getDisabledCarrierSpecialServices(
		accountId: string,
		cancelToken?: CancelToken
	): Promise<models.IAccountDisableSpecialService[]> {
		const url = this.adminApiUrl + 'SpecialService';
		const res = await axios.get<models.IAccountDisableSpecialService[]>(url, {
			params: {
				accountId,
			},
			cancelToken,
		});
		return res.data;
	}

	public async updateCarrierServiceState(
		request: models.IAccountDisableEnableServiceRequest,
		cancelToken?: CancelToken
	) {
		const url = this.adminApiUrl + 'Service';
		const res = await axios.put<any>(url, request, { cancelToken });
		return res.data;
	}

	public async updateCarrierSpecialServiceState(
		request: models.IAccountDisableEnableSpecialServiceRequest,
		cancelToken?: CancelToken
	) {
		const url = this.adminApiUrl + 'SpecialService';
		const res = await axios.put<any>(url, request, { cancelToken });
		return res.data;
	}

	public async getRateSets(companyName: string, cancelToken?: CancelToken): Promise<models.IRateSets> {
		try {
			const url = this.adminApiUrl + `${companyName}/RateSet`;
			const res = await axios.get<models.IRateSets>(url, {
				cancelToken
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

}



// WEBPACK FOOTER //
// ./src/services/admin-account.service.ts